module.exports = __webpack_public_path__ + "img/clear-filter.1ea5b157.png";